import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { FILE_BASE_URL } from '../../Services/baseApiUrl';

function TransferStationDetails() {
    const navigate = useNavigate();
    const location = useLocation();
    const transferStationDetails = location.state?.transferStationDetails || {};
    const getImageSource = (file) => {
        return FILE_BASE_URL + file;
    };

    return (
        <div>
            <div style={{ width: "100%" }}>
                <div className="content">
                    <div className="page-content">
                        <div className="page-header">
                            <div className='row text-end'>
                                <div className='col'>
                                    <button type="button" class="btn btn-danger"
                                        style={{
                                            backgroundColor: "rgb(236, 17, 23)"
                                        }}
                                        onClick={() => navigate("/transfer-station-master")}
                                    >
                                        Back
                                    </button>
                                </div>
                            </div>
                            <h4 style={{ display: "flex", marginBottom: "30px" }}>
                                TransferStation Details of :  {transferStationDetails.transfer_station_name}
                            </h4>
                            <div className="card">
                                <div className="p-3">
                                    <div className="text-start mb-3">
                                        <div className="row">
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Transfer Station Name</label>
                                                    <input
                                                        type="text"
                                                        name="transfer_station_name"
                                                        className="form-control"
                                                        readOnly
                                                        value={transferStationDetails.transfer_station_name}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Transfer Station Code</label>
                                                    <input
                                                        type="text"
                                                        name="transfer_station_code"
                                                        className="form-control"
                                                        readOnly
                                                        value={transferStationDetails.transfer_station_code}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Zone</label>
                                                    <input
                                                        type="text"
                                                        name="zone_name"
                                                        className="form-control"
                                                        readOnly
                                                        value={transferStationDetails.zone_name}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Circle</label>
                                                    <input
                                                        type="text"
                                                        name="circle_name"
                                                        className="form-control"
                                                        readOnly
                                                        value={transferStationDetails.circle_name}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Ward</label>
                                                    <input
                                                        type="text"
                                                        name="ward_name"
                                                        className="form-control"
                                                        readOnly
                                                        value={transferStationDetails.ward_name}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">No Of Containers</label>
                                                    <input
                                                        type="text"
                                                        name="no_of_containers"
                                                        className="form-control"
                                                        readOnly
                                                        value={transferStationDetails.no_of_containers}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Transfer Station Capacity</label>
                                                    <input
                                                        type="text"
                                                        name="transfer_station_capacity"
                                                        className="form-control"
                                                        readOnly
                                                        value={transferStationDetails.transfer_station_capacity}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Latitude</label>
                                                    <input
                                                        type="text"
                                                        name="latitude"
                                                        className="form-control"
                                                        readOnly
                                                        value={transferStationDetails.latitude}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Longitude</label>
                                                    <input
                                                        type="text"
                                                        name="longitude"
                                                        className="form-control"
                                                        readOnly
                                                        value={transferStationDetails.longitude}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">File</label>
                                                    {transferStationDetails.file && (
                                                        <img
                                                            src={getImageSource(transferStationDetails.file)}
                                                            alt="TransferStation Image"
                                                            style={{ maxWidth: "100%", marginTop: "10px" }}
                                                        />
                                                    )}
                                                </div>
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Status</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="status"
                                                        readOnly
                                                        value={transferStationDetails.status === "1" ? "Active" : "Inactive"}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TransferStationDetails
